import React from 'react';
import styled from 'styled-components';
import DialogActions from '@material-ui/core/DialogActions';
import FlatButton from '@material-ui/core/Button';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import { colors } from 'helpers/ColorHelper';
import { AccentColor } from 'helpers/AccentColorHelper';
import { media } from 'helpers/MediaHelper';
import { getTranslatedString } from 'helpers/i18n';

const StyledContainer = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  ${media.mobile`
    padding-top: 50px;
  `};
`;

const StyledHr = styled.div`
  margin-left: 30px;
  margin-right: 30px;
  margin-bottom: 20px;
  border-bottom: 1px solid ${colors.HR_GREY};
`;

const PaysafeTenantConfirmation = ({ handleClose, finalizePayment, paymentWithFee }) => {
  return (
    <StyledContainer>
      <DialogTitle id="payment-dialog">
        <h3
          style={{ textAlign: 'center', margin: 0, paddingBottom: '10px', color: colors.DARK_GRAY }}
        >
          {getTranslatedString('tenantPortal.paysafe.confirmYourDetails')}
        </h3>
      </DialogTitle>

      <DialogContent style={{ paddingLeft: '12px', paddingRight: '12px' }}>
        <StyledHr />
        <div className="row" style={{ padding: '4px 0' }}>
          <div className="col-xs-6" style={{ padding: '0px', textAlign: 'right' }}>
            {getTranslatedString('tenantPortal.paysafe.paymentAmount')}
          </div>
          <div className="col-xs-6" style={{ paddingLeft: '10px', textAlign: 'left' }}>
            {paymentWithFee.formatted_amount}
          </div>
        </div>
        <div className="row" style={{ padding: '4px 0' }}>
          <div className="col-xs-6" style={{ padding: '0px', textAlign: 'right' }}>
            {getTranslatedString('tenantPortal.paysafe.fee')}
          </div>
          <div className="col-xs-6" style={{ paddingLeft: '10px', textAlign: 'left' }}>
            {paymentWithFee.formatted_fee}
          </div>
        </div>
        <div className="row" style={{ padding: '4px 0' }}>
          <div className="col-xs-6" style={{ padding: '0px', textAlign: 'right' }}>
            <strong>{getTranslatedString('tenantPortal.paysafe.totalAmountDue')}</strong>
          </div>
          <div className="col-xs-6" style={{ paddingLeft: '10px', textAlign: 'left' }}>
            <strong>{paymentWithFee.formatted_total}</strong>
          </div>
        </div>
      </DialogContent>
      <DialogActions style={{ justifyContent: 'space-between' }}>
        <FlatButton
          variant="contained"
          onClick={handleClose}
          style={{ color: AccentColor(), backgroundColor: '#fff' }}
        >
          {getTranslatedString('tenantPortal.paysafe.cancelPayment')}
        </FlatButton>
        <FlatButton
          variant="contained"
          onClick={finalizePayment}
          style={{
            color: 'white',
            backgroundColor: AccentColor(),
          }}
        >
          {getTranslatedString('tenantPortal.paysafe.confirmPayment', {
            totalAmount: paymentWithFee.formatted_total,
          })}
        </FlatButton>
      </DialogActions>
    </StyledContainer>
  );
};

export default PaysafeTenantConfirmation;
